/**
 * Calendar Skeleton Component
 * 
 * Loading placeholder while calendar data is fetching
 */

import React from 'react';

export const CalendarSkeleton: React.FC = () => {
  return (
    <div className="animate-pulse bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      {/* Toolbar Skeleton */}
      <div className="flex items-center justify-between mb-4 pb-3 border-b border-gray-200">
        <div className="flex space-x-2">
          <div className="w-8 h-8 bg-gray-200 rounded"></div>
          <div className="w-16 h-8 bg-gray-200 rounded"></div>
          <div className="w-8 h-8 bg-gray-200 rounded"></div>
        </div>
        <div className="w-40 h-8 bg-gray-200 rounded"></div>
        <div className="flex space-x-2">
          <div className="w-16 h-8 bg-gray-200 rounded"></div>
          <div className="w-16 h-8 bg-gray-200 rounded"></div>
          <div className="w-16 h-8 bg-gray-200 rounded"></div>
          <div className="w-16 h-8 bg-gray-200 rounded"></div>
        </div>
      </div>

      {/* Calendar Grid Skeleton */}
      <div className="grid grid-cols-7 gap-1">
        {/* Header Row */}
        {Array.from({ length: 7 }).map((_, i) => (
          <div key={`header-${i}`} className="h-10 bg-gray-100 rounded"></div>
        ))}
        
        {/* Date Cells */}
        {Array.from({ length: 35 }).map((_, i) => (
          <div key={`cell-${i}`} className="h-24 bg-gray-50 rounded p-2 space-y-1">
            <div className="w-6 h-4 bg-gray-200 rounded"></div>
            <div className="w-full h-3 bg-gray-200 rounded"></div>
            <div className="w-3/4 h-3 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>

      {/* Loading Text */}
      <div className="text-center mt-6 text-sm text-gray-500">
        Loading delivery calendar...
      </div>
    </div>
  );
};

